<template>

    <el-row>

        <el-col :span="24" class="mb-3">

            <p class="mb-1 comfy-text">Escoge quién prestará el servicio:</p>

            <el-radio-group v-model="servicio.genero" class="w-100">
                <el-radio-button label="hombre" class="w-33">
                    <p class="font-weight-bold comfy-second-text mb-0">Prefiero Hombre</p>
                </el-radio-button>
                <el-radio-button label="mujer" class="w-33">
                    <p class="font-weight-bold comfy-second-text mb-0">Prefiero Mujer</p>
                </el-radio-button>
                <el-radio-button label="aleatorio" class="w-33">
                    <p class="font-weight-bold comfy-second-text mb-0">Cualquiera de los dos</p>
                </el-radio-button>
            </el-radio-group>

        </el-col>

        <el-col :span="24" class="mb-3">

            <p class="mb-1 comfy-text">Elige una de las siguientes opciones:</p>

            <el-radio-group v-model="servicio.tipo" class="w-100">
                <el-radio-button label="sencillo" class="w-33">
                    <img class="h-60" :src="url + '/frontend/img/comfy/icon_sencillo.png'" alt="Sencillo"><br><br>
                    <p class="font-weight-bold comfy-second-text mb-0">Sencillo<span class="d-block grey-text s-10 font-weight-normal mh-25">Para una persona.</span></p>
                </el-radio-button>
                <el-radio-button label="btb" class="w-33">
                    <img class="h-60" :src="url + '/frontend/img/comfy/icon_btb.png'" alt="Back to back"><br><br>
                    <p class="font-weight-bold comfy-second-text mb-0">Back-to-Back<span class="d-block grey-text s-10 font-weight-normal mh-25">Para dos personas,<br> una después de la otra,<br>un mismo ó misma PRO.</span></p>
                </el-radio-button>
                <!-- <el-radio-button label="btb" class="w-33">
                    <img class="h-60" :src="url + '/frontend/img/comfy/icon_btb.png'" alt="Sencillo"><br><br>
                    <p class="font-weight-bold comfy-second-text mb-0">Back-to-Back<br><span class="font-italic ivy-bold">Mom Pack</span><span class="d-block grey-text s-10 font-weight-normal mh-25">2 Masajes consecutivos<br>con un mismo o misma Pro</span></p>
                </el-radio-button> -->
                <el-radio-button label="doble" class="w-33">
                    <img class="h-60" :src="url + '/frontend/img/comfy/icon_doble.png'" alt="Grupal"><br><br>
                    <p class="font-weight-bold comfy-second-text mb-0">Doble<span class="d-block grey-text s-10 font-weight-normal mh-25">Para 2 a 5 personas,<br> al mismo tiempo.</span></p>
                </el-radio-button>
            </el-radio-group>

        </el-col>

        <el-col :span="24" v-if="servicio.tipo">
            <p class="mb-1 comfy-text">Elige una de las siguientes opciones:</p>

            <el-radio-group v-model="servicio.busqueda" class="w-100">
                <el-radio-button label="fecha" class="w-49">
                    <img :src="url + '/frontend/img/comfy/icon_fecha.png'" alt="Sencillo"><br><br>
                    <p class="font-weight-bold comfy-second-text mb-0">Fecha y hora definidas<span class="d-block grey-text s-10 font-weight-normal mh-25">Se asignará un o una<br> PRO aleatoriamente</span></p>
                </el-radio-button>
                <el-radio-button label="masajista" class="w-49">
                    <img :src="url + '/frontend/img/comfy/icon_masajista.png'" alt="Sencillo"><br><br>
                    <p class="font-weight-bold comfy-second-text mb-0">Quiero escoger mi PRO<span class="d-block grey-text s-10 font-weight-normal mh-25">Escoges según la disponibilidad<br> de la o el PRO</span></p>
                </el-radio-button>
            </el-radio-group>

        </el-col>

    </el-row>

</template>

<style type="text/css">
    .h-60 {
        height: 60px;
    }
    .el-radio-button__inner{
        padding: 10px;
    }
</style>

<script>
    export default {
        props: [
            'url', 'servicio'
        ],
        data() {
            return {

            }
        },
        watch: {

        },
        methods: {

        },
        mounted() {
            // console.log('--- TipoBusqueda component mounted ---')
        }
    };
</script>